import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "./../../../reducers";
// import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { Combo2Service, WorkOrderService, PurchaseOrderService } from "./../../../services/index";
@Component({
  selector: "addEditInvoice",
  templateUrl: "./addRackmaster.html",
})
export class addRackmaster {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  whList : any = [];
  nameList = ["1","2" ,"3","4","5","6","7","8"];

  codeList: any;
  seasonList: any;

  execApi: boolean = true;
  //  isEdit: boolean = false;
  invoicedata: any = {};
  delPartyList: any;
  party_id: any;
  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  invalidList: any = [];
  colorList: any = [];
  qualityList: any = [];
  fabColorlist: any = [];
  fabColorTemplist: any = [];

  mode: string;
  saveEvent: any;
  agentList: any;
  uniqueTypeList: any;
  prefixList: any;
  bl = [];
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  isShow : boolean = false;

  sampleList = [{ name: "YES" }, { name: "NO" }];

  partyList: any = [];
  varietyList = ["CHECKS","PLAIN"];
  widthList = ["36", "44", "58"];
  styleList = ["FORMAL", "CASUAL"];
  partyOrderno: any;
  order: any;
  sale_type: any;
  expand = true;
  upd_type: any;
  res = []
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;
  qualitylist: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
  
   this.saveEvent = val["data"].tabevent;
    this.getSetDetails();
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: WorkOrderService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService

  ) {
    this.row = {
      width: "",
      size: "",
      sleeve: "",
      type: "",
      
    };
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {

    // this.getrackName()
    this.tableScroll();
    this.invoicedata.mode = this.mode;

  }
  ngAfterViewInit() {
    $("#invoice_type").focus();
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }

  OnselectpartyId(type){
   let temp = this.partyList.filter(el=>el.code == type);
   this.invoicedata.party_id = temp[0].party_id;


  }

  

 getrackName() {

    let params = {
      page_type: 'Rack',
      whCode: this.invoicedata.wh_code   
    }
     let that = this
    that.salesinvservice.getSetDetails(params).then((res: any) => {
      if (res.data.length > 0) {
        that.invoicedata.rackname_from = res.data[0].max_rackName;
      }


    })

  }
  buttonStyle() {
    const style = {
     Position : "relative",
      left: this.mode == "Add" ? "90%" : "73% !important",
      bottom: "54px"
    };
    return style;
  }

 validateInputs(): boolean {
    let errorMessage = '';

    if (!this.invoicedata.wh_code) {
      errorMessage = 'Warehouse Code is required';
      swal("ERROR", `${errorMessage}`,"error")
      return false;
    }

    if (!/^L\d+$/.test(this.invoicedata.line_from)) {
      errorMessage =
        'Line From must start with Letter followed by a number (e.g., L1)';
        swal("ERROR", `${errorMessage}`,"error")
      return false;
    }

    if (this.invoicedata.line_to && !/^L\d+$/.test(this.invoicedata.line_to)) {
      errorMessage =
        'Line To must start with Letter followed by a number (e.g., L5)';
          swal("ERROR", `${errorMessage}`,"error")
      return false;
    }

    const lineStart = parseInt(this.invoicedata.line_from.slice(1), 10);
    const lineEnd = this.invoicedata.line_to
      ? parseInt(this.invoicedata.line_to.slice(1), 10)
      : lineStart;
    if (lineEnd < lineStart) {
      errorMessage = 'Line To must be >= Line From';
        swal("ERROR", `${errorMessage}`,"error")
      return false;
    }

  
    if (!/^R\d+$/.test(this.invoicedata.rackname_from)) {
      errorMessage = 'RackName must start with Letter followed by a number (e.g., R1)';
        swal("ERROR", `${errorMessage}`,"error")
      return false;
    }

    if (this.invoicedata.rackname_to && !/^R\d+$/.test(this.invoicedata.rackname_to)) {
      errorMessage =
        'RackName To must start with Letter followed by a number (e.g., R5)';
          swal("ERROR", `${errorMessage}`,"error")
      return false;
    }

     if (!/^R\d+$/.test(this.invoicedata.rackname_from)) {
      errorMessage = 'RackName must start with Letter followed by a number (e.g., R1)';
        swal("ERROR", `${errorMessage}`,"error")
      return false;
    }

     if (!/^[A-Z]$/.test(this.invoicedata.bayno_from)) {
      errorMessage = 'Bay No From must be A-Z';
        swal("ERROR", `${errorMessage}`,"error")
      return false;
    }

     if (this.invoicedata.bayno_to && !/^[A-Z]$/.test(this.invoicedata.bayno_to)) {
      errorMessage = 'BayNo To must be A-Z';
        swal("ERROR", `${errorMessage}`,"error")
      return false;
    }

    // if (this.invoicedata.rackname_to && !/^[A-Z]$/.test(this.invoicedata.rackname_to)) {
    //   errorMessage = 'Rack To must be A-Z';
    //     swal("ERROR", `${errorMessage}`,"error")
    //   return false;
    // }

    const rackStart = this.invoicedata.rackname_from.charCodeAt(0);
    const rackEnd = this.invoicedata.rackname_to ? this.invoicedata.rackname_to.charCodeAt(0) : rackStart;
    if (rackEnd < rackStart) {
      errorMessage = 'Rack To must be >= Rack From';
        swal("ERROR", `${errorMessage}`,"error")
      return false;
    }

    // if (!this.invoicedata.bayno_from || this.invoicedata.bayno_from < 1) {
    //   errorMessage = 'Bay From must be a positive number';
    //     swal("ERROR", `${errorMessage}`,"error")
    //   return false;
    // }

    // if (this.invoicedata.bayno_to && this.invoicedata.bayno_to < this.invoicedata.bayno_from) {
    //   errorMessage = 'Bay To must be >= Bay From';
    //     swal("ERROR", `${errorMessage}`,"error")
    //   return false;
    // }
  if (!this.invoicedata.formal && !this.invoicedata.casual) {
      errorMessage = 'Capacity is required';
      swal("ERROR", `${errorMessage}`,"error")
      return false;
    }
    return true;
  }


  generateRackLocations() {
    if (!this.validateInputs()) return;

    this.data.invoiceList = [];

    const lineStart = parseInt(this.invoicedata.line_from.slice(1), 10);
    const lineEnd = this.invoicedata.line_to
      ? parseInt(this.invoicedata.line_to.slice(1), 10)
      : lineStart;
    // Number(a.substring(1))
    const rackStart = this.invoicedata.rackname_from.substring(1);
    const rackEnd = this.invoicedata.rackname_to ? this.invoicedata.rackname_to.substring(1) : rackStart;
    const bayStart = this.invoicedata.bayno_from.charCodeAt(0);
    const bayEnd = this.invoicedata.bayno_to ? this.invoicedata.bayno_to.charCodeAt(0) : bayStart;

    console.log("check start:::", rackStart, "rackEnddddddddd", rackEnd)
    // const capacity = this.invoicedata.capacity
       const formal = this.invoicedata.formal 
        const casual = this.invoicedata.casual || 0

    const wh_code = this.invoicedata.wh_code
    for (let line = lineStart; line <= lineEnd; line++) {
      for (let rack = rackStart; rack <= rackEnd; rack++) {
        for (let bay = bayStart; bay <= bayEnd; bay++) {
          const rack_line = `L${line}`;
          const rack_name = `R${rack}`;
          const bay_no = String.fromCharCode(bay)
          const location_code = `${this.invoicedata.wh_code}-${rack_line}-${rack_name}-${bay_no}`;


         console.log(rack_line, rack_name, bay_no, location_code )
          this.data.invoiceList.push({
            wh_code,
            rack_line,
            rack_name,
            bay_no,
            location_code,
            formal,
            casual

          });
        }
      }
    }

    console.log(this.data.invoiceList, "check After dataaa")
  }

  onEnterKeyPressed(nextEl: string) {

    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }

  }

  calcRange() {
  if (!this.invoicedata.prefix){
    swal(`ERROR`, `Please Enter Prefix!`, `error` );
    return;
  } 
    let params = {
      page_type: 'Bag',
      prefix: this.invoicedata.prefix   
    }
    this.salesinvservice.getSetDetails(params).then((res: any) => {

      let List = res.data;
      // Determine next series number
      if (List.length > 0) {
        const maxSeries = Math.max(...List.map(entry => entry.series));
        this.invoicedata.from_range = maxSeries + 1;
      } else {
        this.invoicedata.from_range = 1;
      }

      // Set barcode using determined prefix and series
      this.invoicedata.barcode = `${this.invoicedata.prefix}-${this.invoicedata.from_range}`;
    })

  }



 
  checkAll(evant, all) {
    if (evant.target.checked) {
      this.listSelected = this.data.invoiceList;
      $("input:checkbox").prop("checked", evant.target.checked);
    } else {
      $("input:checkbox").prop("checked", evant.target.checked);
      this.listSelected = [];
    }
  }
  getEditMode(ind) {
      
    this.data.invoiceList[ind].isEdit = !this.data.invoiceList[ind].isEdit;

  }

  EditDet() {

    let that = this;
    swal({
      title: "Are you sure to Clear the TableGrid?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.invoiceList.length >= 1) {
          
          that.data.invoiceList = [];

      
        }
      },
      function (dismiss) { }
    );
  }
getSetDetails() {
 let params = {
  page_type : 'Warehouse'
 }
    this.salesinvservice.getSetDetails(params).then((res: any) => {

      this.whList = res.data;
   

    });
  }
 Barcodeprint(){

   let params : any = {}
   let data = this.data.invoiceList.map(item => ({ item: 'RACK', barcode: item.location_code, whCode: item.wh_code}));
   params['data'] = JSON.stringify(data)
   console.log("check Baeforre print", params)
   this.salesinvservice.bagBarcodeprint(params).then(function (res: any) { })
 }
  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  // getAutoNumber() {

  //   this.salesinvservice.getMultiFabAuto({}).then((res: any) => {
  //     this.invoicedata.ref_no = res;
  //   });
  // }


  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }

  oncheckemptyrow(saveType){
       
    let params: any = Object.assign({}, this.invoicedata);
    params["tabevent"] = undefined;
    params["data"] = JSON.stringify(this.data.invoiceList);
    let that = this;

    swal({
      title: "Are you sure to save this Changes?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoadMask = that.salesinvservice
        .saverackMasterDetails(params)
        .then(function (res: any) {
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            if(saveType == 'print'){
            that.Barcodeprint();
            }
            that.isShow = false;
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          }
          else if (res.success === false && res.duplicates && res.duplicates.length > 0) {
            // Format the duplicate entries into a message string
                  let duplicateMessage = "The following rack location IDs already exist:<br>";
            res.duplicates.forEach(duplicate => {
              duplicateMessage += `<b style="font-weight: bold;">- ${duplicate.location_code}</b> (Rack: <b style="font-weight: bold;">${duplicate.rack_name}</b>, Line: <b style="font-weight: bold;">${duplicate.rack_line}</b>)<br>`;
            });



            // Show the duplicate error message using SweetAlert (supporting HTML)
            swal({
              title: "ERROR",
              html: `${res.message}<br><br>${duplicateMessage}`, // Use HTML here
              type: "error"
            });
          } else if (res.success === false) {

            swal("ERROR", res.message, "error");
          } 
        })
        .catch(function (error: any) {
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
 
}
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/RackMaster/addRackmaster.ts